import React, { useState, useEffect } from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableColumn,
  TableRow,
  TableCell,
  Card,
  CardBody,
  CardHeader,
  Divider,
  Input,
  Button,
} from '@nextui-org/react';
import { getCompletedTask, getTasks } from 'common/src/api/tasks';

const CompletionStatsTable: React.FC = () => {
  const [startDate, setStartDate] = useState(
    new Date(new Date().setMonth(new Date().getMonth() - 1)).toISOString().split('T')[0]
  );
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [stats, setStats] = useState({ total: 0, completed: 0, percentage: 0 });

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const fetchStats = async () => {
    // Query for total tasks

    const { count: totalCount } = await getTasks(startDate, endDate);
    // Query for completed tasks
    const { count: completedCount } = await getCompletedTask(startDate, endDate);
    const total = totalCount || 0;
    const completed = completedCount || 0;
    const percentage = total > 0 ? (completed / total) * 100 : 0;

    setStats({
      total,
      completed,
      percentage: Math.round(percentage * 100) / 100,
    });
  };

  const setQuickDateRange = (days: number) => {
    const end = new Date();
    const start = new Date();
    start.setDate(end.getDate() - days);
    setStartDate(start.toISOString().split('T')[0]);
    setEndDate(end.toISOString().split('T')[0]);
  };

  return (
    <Card className="max-w-[600px] mx-auto">
      <CardHeader className="flex flex-col items-start gap-4">
        <h2 className="text-2xl font-bold">Estadísticas de Tasks Completados</h2>
        <div className="w-full">
          <h3 className="text-lg font-semibold mb-2">Selección Rápida de Fechas</h3>
          <div className="flex flex-wrap gap-2">
            <Button size="sm" onClick={() => setQuickDateRange(1)}>
              Ayer
            </Button>
            <Button size="sm" onClick={() => setQuickDateRange(3)}>
              Últimos 3 Días
            </Button>
            <Button size="sm" onClick={() => setQuickDateRange(7)}>
              Última Semana
            </Button>
            <Button size="sm" onClick={() => setQuickDateRange(30)}>
              Último Mes
            </Button>
          </div>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-2">Selección Fecha Exacta</h3>
          <div className="flex flex-col sm:flex-row gap-4 w-full">
            <Input
              type="date"
              label="Fecha de Inicio"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <Input
              type="date"
              label="Fecha de Fin"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>
      </CardHeader>
      <Divider />
      <CardBody>
        <Table aria-label="Estadísticas de Tasks Completados">
          <TableHeader>
            <TableColumn>TAREAS TOTALES</TableColumn>
            <TableColumn>TAREAS COMPLETADAS</TableColumn>
            <TableColumn>PORCENTAJE DE FINALIZACIÓN</TableColumn>
          </TableHeader>
          <TableBody>
            <TableRow key="1">
              <TableCell>{stats.total}</TableCell>
              <TableCell>{stats.completed}</TableCell>
              <TableCell>{stats.percentage}%</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default CompletionStatsTable;
